var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-630.324 -434.366)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M648.151,444.549h-7.383a.491.491,0,0,1-.489-.491v-7.716a.687.687,0,0,0-.667-.7,9.282,9.282,0,0,0-9.288,9.349,9.392,9.392,0,0,0,9.626,9.247,9.282,9.282,0,0,0,8.894-8.972.693.693,0,0,0-.667-.719h-.025Z",
    transform: "translate(0 0.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M641.344,434.366a.6.6,0,0,0-.6.6h0v7.688a.6.6,0,0,0,.6.6h7.424a.6.6,0,0,0,.6-.58V442.4A8.039,8.039,0,0,0,641.344,434.366Z",
    transform: "translate(0.957)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/charts.b51651180c5edd6ce95172ea84a6ea5f.svg";
export { ForwardRef as ReactComponent };